export default "__VITE_PUBLIC_ASSET__1696fd58__"